import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import { HttpService } from '../../services/http.service';
import './mini-basket.component.scss';
import * as $ from 'jquery';
var MiniBasket = /** @class */ (function (_super) {
    tslib_1.__extends(MiniBasket, _super);
    function MiniBasket(element) {
        var _this = _super.call(this, element) || this;
        _this.useFullURL = false;
        return _this;
    }
    MiniBasket.prototype.init = function () {
        this.miniBasketHeaderIcon = this.element.closest('.mini-basket__header-icon');
        if (window.location.href.includes("useFullURL")) {
            this.useFullURL = true;
        }
        else {
            this.useFullURL = false;
        }
        // get MiniCart
        if (this.miniBasketHeaderIcon) {
            this.initialiseCart();
        }
    };
    MiniBasket.prototype.bindEvents = function () {
        if (this.miniBasketHeaderIcon) {
            this.miniBasketHeaderIcon.addEventListener('click', function (pEvent) {
                $('body').find('#mini-basket-items-modal').removeClass('mini-basket__modal--close');
                $('body').find('#mini-basket-items-modal').removeClass('mini-basket__modal--closed');
            });
            $('body').on('click', '#mini-basket-items-modal .minicart-close', function (event) {
                $(event.currentTarget).closest('#mini-basket-items-modal').addClass('mini-basket__modal--close');
                setTimeout(function () {
                    $(event.currentTarget).closest('#mini-basket-items-modal').addClass('mini-basket__modal--closed');
                }, 250);
            });
            $('body').on('click', '#mini-basket-items-modal .remove-btn.remove-products.cart-delete-confirmation-btn', { getMiniCart: this.getMiniCart, getMiniCartUndo: this.getMiniCartUndo, buildCart: this.buildCart }, this.removeProductFromMiniCartEvent);
            $('body').on('click', '#mini-basket-items-modal .undo-to-cart.product-detail', { getMiniCart: this.getMiniCart, buildCart: this.buildCart }, this.addUndoProductsToMiniCartEvent);
        }
    };
    MiniBasket.prototype.initialiseCart = function () {
        this.getMiniCart(this.buildCart);
    };
    // Get Mini Cart
    MiniBasket.prototype.getMiniCart = function (buildCart) {
        if (!this.http) {
            this.http = new HttpService();
        }
        if (!this.analyticsService) {
            this.analyticsService = new AnalyticsService();
        }
        // Loader
        if ($('body').find('#mini-basket-items-container .minicart').length > 0) {
            $('body').find('#mini-basket-items-container .minicart')[0].innerHTML = '';
        }
        if ($('body').find('#mini-basket-items-container #mini-basket-items-container-loader').length > 0) {
            $('body').find('#mini-basket-items-container #mini-basket-items-container-loader').removeClass('hidden');
        }
        var _headers = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest',
                'Analytics-User': this.analyticsService.getDtmVisitorID()
            }
        };
        // url
        var url = '';
        var enableFeatureMinicart = false;
        this.http.getHeaders("/file_source/assets/components/search_coza/commerceurls.json", _headers).then(function (pUrls) {
            if (pUrls.data) {
                if (pUrls.data.enableFeatureMinicart) {
                    enableFeatureMinicart = pUrls.data.enableFeatureMinicart;
                    if (enableFeatureMinicart && pUrls.data.miniBasket) {
                        url = pUrls.data.miniBasket;
                        $.get(url)
                            .done(function (data, status) {
                            if (data) {
                                var htmlCart = $(data);
                                if ($(htmlCart).find('span.minicart-quantity').length > 0) {
                                    var cartQuantity = $(htmlCart).find('span.minicart-quantity')[0].innerHTML;
                                    if (Number(cartQuantity) > 0) {
                                        if ($('.mini-basket__header-icon').find('span.minicart-quantity').length > 0) {
                                            $('.mini-basket__header-icon').find('span.minicart-quantity')[0].innerHTML = cartQuantity;
                                        }
                                        else {
                                            $('.mini-basket__header-icon').append("<span class='minicart-quantity'>" + Number(cartQuantity) + "</span>");
                                        }
                                        $('body').find('div.mini-basket.mini-basket__header-icon').removeClass('mini-basket__icon-hide');
                                        buildCart(htmlCart[0].outerHTML);
                                    }
                                    else {
                                        $('body').find('div.mini-basket.mini-basket__header-icon').addClass('mini-basket__icon-hide');
                                    }
                                }
                            }
                        })
                            .fail(function (data, status, error) {
                            // empty
                        });
                    }
                }
            }
        }).catch(function (pError) {
            console.log(pError);
        });
    };
    MiniBasket.prototype.removeProductFromMiniCartEvent = function (event) {
        var cTarget = event.currentTarget;
        var productsLineItems = $('body').find('#mini-basket-items-container .minicart .product-line-item');
        // Loader
        if ($('body').find('#mini-basket-items-container .minicart').length > 0) {
            $('body').find('#mini-basket-items-container .minicart')[0].innerHTML = '';
        }
        if ($('body').find('#mini-basket-items-container #mini-basket-items-container-loader').length > 0) {
            $('body').find('#mini-basket-items-container #mini-basket-items-container-loader').removeClass('hidden');
        }
        var productId = $(cTarget).attr('data-pid');
        var productInsuranceId = $(cTarget).attr('data-insurancePid');
        var productInsurancePlanId = $(cTarget).attr('data-insurancePlanid');
        var productUuId = $(cTarget).attr('data-uuid');
        var productsLineItemIndex = 0;
        if (productsLineItems.length > 0) {
            for (var i = 0; i < productsLineItems.length; i++) {
                if (!productsLineItems[i].classList.contains('insurance-line') && productsLineItems[i].getAttribute('data-uuid') === productUuId) {
                    productsLineItemIndex = i;
                    break;
                }
            }
        }
        if (productsLineItems[productsLineItemIndex + 1]) {
            if (productsLineItems[productsLineItemIndex + 1].classList.contains('insurance-line')
                && productsLineItems[productsLineItemIndex + 1].hasAttribute('data-insurance-pid')) {
                productInsuranceId = productsLineItems[productsLineItemIndex + 1].getAttribute('data-insurance-pid');
            }
        }
        var urlParams = {
            pid: (productId) ? productId : null,
            insurancePid: (productInsuranceId) ? productInsuranceId : null,
            insurancePlanid: (productInsurancePlanId) ? productInsurancePlanId : null,
            uuid: (productUuId) ? productUuId : null
        };
        var url = '';
        if (this.useFullURL) {
            url = "https://uat.standardbank.co.za/commerce/cart-remove-product";
        }
        else {
            url = "/commerce/cart-remove-product";
        }
        $.get(url, urlParams)
            .done(function (data, status) {
            if (data) {
                if (data.basket.numItems > 0) {
                    event.data.getMiniCart(event.data.buildCart);
                }
                else {
                    event.data.getMiniCartUndo(productId, productInsuranceId, productInsurancePlanId, productUuId, event.data.buildCart);
                }
            }
        })
            .fail(function (data, status, error) {
            // empty
        });
    };
    MiniBasket.prototype.addUndoProductsToMiniCartEvent = function (event) {
        var cTarget = event.currentTarget;
        var _miniBasket = $('body').find('#mini-basket-items-container .minicart');
        var productId = $(cTarget).attr('data-pid');
        var productInsuranceId = $(cTarget).attr('data-insuranceid');
        var csrf_tokenInput = $(_miniBasket).find('input[name="csrf_token"]');
        var productQuantityInput = $(_miniBasket).find('input.quantity-select');
        var csrf_token = '';
        if (csrf_tokenInput.length > 0) {
            csrf_token = csrf_tokenInput[0].getAttribute('value');
        }
        var productQuantityVal = '';
        if (productQuantityInput.length > 0) {
            productQuantityVal = productQuantityInput[0].getAttribute('value');
        }
        // Loader
        if ($('body').find('#mini-basket-items-container .minicart').length > 0) {
            $('body').find('#mini-basket-items-container .minicart')[0].innerHTML = '';
        }
        if ($('body').find('#mini-basket-items-container #mini-basket-items-container-loader').length > 0) {
            $('body').find('#mini-basket-items-container #mini-basket-items-container-loader').removeClass('hidden');
        }
        var productQuantity = 0;
        if (productQuantityVal !== '') {
            productQuantity = Number(productQuantityVal);
        }
        var product = {
            pid: (productId) ? productId : null,
            insuranceId: (productInsuranceId) ? productInsuranceId : null,
            quantity: (productQuantity) ? productQuantity : null,
            csrf_token: (csrf_token) ? csrf_token : null,
            options: [],
            isRedirect: false
        };
        var url = '';
        if (this.useFullURL) {
            url = "https://uat.standardbank.co.za/commerce/add-lending-product";
        }
        else {
            url = "/commerce/add-lending-product";
        }
        $.post(url, product)
            .done(function (data, status) {
            if (data) {
                event.data.getMiniCart(event.data.buildCart);
            }
        })
            .fail(function (data, status, error) {
            // empty
        });
    };
    MiniBasket.prototype.getMiniCartUndo = function (productId, productInsuranceId, productInsurancePlanId, productUuId, buildCart) {
        // Loader
        if ($('body').find('#mini-basket-items-container .minicart').length > 0) {
            $('body').find('#mini-basket-items-container .minicart')[0].innerHTML = '';
        }
        if ($('body').find('#mini-basket-items-container #mini-basket-items-container-loader').length > 0) {
            $('body').find('#mini-basket-items-container #mini-basket-items-container-loader').removeClass('hidden');
        }
        var urlParams = {
            pid: (productId) ? productId : null,
            insurancePid: (productInsuranceId) ? productInsuranceId : null,
            insurancePlanid: (productInsurancePlanId) ? productInsurancePlanId : null,
            uuid: (productUuId) ? productUuId : null
        };
        var url = '';
        if (this.useFullURL) {
            url = "https://uat.standardbank.co.za/commerce/minicartundo";
        }
        else {
            url = "/commerce/minicartundo";
        }
        $.get(url, urlParams)
            .done(function (data, status) {
            if (data) {
                var htmlCart = $(data);
                if ($(htmlCart).find('span.minicart-quantity').length > 0) {
                    var cartQuantity = $(htmlCart).find('span.minicart-quantity')[0].innerHTML;
                    if (Number(cartQuantity) <= 0) {
                        $('body').find('div.mini-basket.mini-basket__header-icon').addClass('mini-basket__icon-hide');
                        buildCart(htmlCart[0].outerHTML);
                    }
                    else {
                        $('body').find('div.mini-basket.mini-basket__header-icon').removeClass('mini-basket__icon-hide');
                    }
                }
            }
        })
            .fail(function (data, status, error) {
            // empty
        });
    };
    MiniBasket.prototype.buildCart = function (cartHtml) {
        if ($('body').find('#mini-basket-items-container #mini-basket-items-container-loader').length > 0) {
            $('body').find('#mini-basket-items-container #mini-basket-items-container-loader').addClass('hidden');
        }
        if ($('body').find('#mini-basket-items-container .minicart').length > 0) {
            $('body').find('#mini-basket-items-container .minicart')[0].innerHTML = cartHtml;
        }
        else {
            var theHTML = "\n\t\t\t<div id=\"mini-basket-items-modal\" class=\"modal js-apply-now-modal mini-basket__modal--closed\">\n\t\t\t\t<div class=\"modal-dialog modal__dialog modal__dialog--medium\">\n\t\t\t\t\t<div class=\"modal-content modal__content\">\n\t\t\t\t\t\t<div class=\"modal-body modal__body apply-now__modal-body\">\n\t\t\t\t\t\t\t<div class=\"mini-basket__modal--full-display\">\n\t\t\t\t\t\t\t\t<div id=\"mini-basket-items-container\" name=\"mini-basket-items-container\" class=\"mini-basket-items-container\">\n\t\t\t\t\t\t\t\t\t<div id=\"mini-basket-items-container-loader\" class=\"form-container__loader hidden\">\n\t\t\t\t\t\t\t\t\t\t<img class=\"search__results-busy\" src=\"/file_source/assets/icons/spinner.svg\" />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"minicart\">\n\t\t\t\t\t\t\t\t\t\t" + cartHtml + "\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>";
            if ($('body main').length > 0) {
                $('body main').append(theHTML);
            }
            else {
                if ($('body').length > 0) {
                    $('body').append(theHTML);
                }
            }
        }
    };
    return MiniBasket;
}(Base));
export { MiniBasket };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/mini-basket/mini-basket.component.ts
// module id = 984
// module chunks = 0